<template>
  <faq-standalone-main :slug="slug" :url="url" />
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class FaqStandalonePage extends Vue {
  get slug() {
    return this.$route.params.slug
  }

  get url() {
    return `https://${this.$config.public.envUrl}${this.$route.path}`
  }
}

export default toNative(FaqStandalonePage)
</script>
